import { TokenWithBalance, TokenWithValue } from '@/domain/common/types'
import { InjectedActionsContext, Objective } from '@/features/actions/logic/types'
import { DialogActionsPanel } from '@/features/dialogs/common/components/DialogActionsPanel'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog, PageStatus } from '@/features/dialogs/common/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { UseFormReturn } from 'react-hook-form'
import { IsolatedPairOverview } from '@/features/isolated-details/types'
import { PositionOverview } from '../logic/types'
import { RepayOverviewPanel } from '../components/RepayOverviewPanel'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'

export interface RepayViewProps {
  walletOverview: MyWalletProps
  repayOptions: TokenWithBalance[]
  repayAsset: TokenWithValue
  assetsToRepayFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  objectives: Objective[]
  actionsContext: InjectedActionsContext
  pageStatus: PageStatus
  pairOverview: IsolatedPairOverview
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
  updatedLiquidationPrice: NormalizedUnitNumber
}

export function RepayView({
  walletOverview,
  repayOptions,
  assetsToRepayFields,
  form,
  objectives,
  actionsContext,
  pageStatus,
  repayAsset,
  currentPositionOverview,
  updatedPositionOverview,
  updatedLiquidationPrice,
}: RepayViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>{`Repay ${repayAsset.token.symbol}`}</DialogTitle>

      <FormAndOverviewWrapper>
        <DialogForm
          form={form}
          assetsFields={assetsToRepayFields}
          selectorAssets={repayOptions}
          balanceType="protocol"
        />
        <RepayOverviewPanel
          repayAsset={repayAsset}
          walletOverview={walletOverview}
          currentPositionOverview={currentPositionOverview}
          updatedPositionOverview={updatedPositionOverview}
          updatedLiquidationPrice={updatedLiquidationPrice}
        />
      </FormAndOverviewWrapper>
      <DialogActionsPanel
        context={actionsContext}
        objectives={objectives}
        onFinish={pageStatus.goToSuccessScreen}
        enabled={pageStatus.actionsEnabled}
      />
    </MultiPanelDialog>
  )
}
